import { translate } from "app/filters/i18nFilter";

export interface IRegionObject {
    id: number;
    name: string;
    text?: string;
    countries: number[];
    permitted?: boolean;
}

interface IRegionService {
    getRegions(): IRegionObject[];
    getRegionById(regionId: string): IRegionObject;
    getRegionByName(regionName: string): IRegionObject | undefined;
}

class RegionService implements IRegionService {
    private readonly regions: IRegionObject[];

    constructor(regions: IRegionObject[]) {
        this.regions = regions.map((item: IRegionObject) => ({
            ...item,
            text: translate(`si.common.region.${item.name}.label`),
        }));
    }

    getRegions(): IRegionObject[] {
        return this.regions;
    }

    getRegionById(regionId: string): IRegionObject {
        return this.regions.find((item) => item.id.toString() === regionId);
    }

    getRegionByName(regionName: string): IRegionObject | undefined {
        return this.regions.find((item) => item.name === regionName);
    }
}

let regionService: RegionService | undefined;

const getRegionService = (): RegionService => {
    if (!regionService) {
        const regionsData = window.similarweb?.config?.regions || [];
        regionService = new RegionService(regionsData);
    }

    return regionService;
};

const regionServiceFacade: IRegionService = {
    getRegions: () => getRegionService().getRegions(),
    getRegionById: (regionId: string) => getRegionService().getRegionById(regionId),
    getRegionByName: (regionName: string) => getRegionService().getRegionByName(regionName),
};

export default regionServiceFacade;
